import { Popup } from "@hatch-digital-nl/abs-storybook/legacy";
import { updateCertificateModalState } from "../../CreateCertificateModalSlice";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { JSX } from "react";
import { CreateFormContentStepOne } from "./components/CreateFormContentStepOne";
import { CreateFormHeader } from "./components/CreateFormHeader";
import { CreateFormContentStepTwo } from "./components/CreateFormContentStepTwo";

export const EstablishmentManagerCreateFormAtQualification =
    (): JSX.Element => {
        const dispatch = useAppDispatch();
        const { formStep, selectedQualification } = useAppSelector(
            (state) => state.createCertificateModal,
        );

        return (
            <Popup
                className={"c-create-certificates-modal"}
                title={selectedQualification.name}
                onCloseClick={() => {
                    dispatch(
                        updateCertificateModalState({
                            isLoading: false,
                            error: null,
                            isCreateCertificateModalOpen: false,
                            selectedQualification: null,
                            isAtQualification: false,
                            isPostCreateCertificateSuccess: true,
                            expiresAtValues: {},
                            validAtValues: {},
                            selectedEmployees: [],
                            formStep: 1,
                        }),
                    );
                }}
            >
                <CreateFormHeader />
                {formStep === 1 && <CreateFormContentStepOne />}
                {formStep === 2 && <CreateFormContentStepTwo />}
            </Popup>
        );
    };
